export function getMainContentScrollContainer(): HTMLElement | null {
  return document.querySelector<HTMLElement>('.main-content')
}
